module.exports = __webpack_public_path__ + "media/images/favicons/favicon-1e2198399123765e435b9f233658f62b.ico";